import { Eyebrow, PillButton, Reveal } from "@/components/site/Bits";

export default function ClosingCTA({ eyebrow = "Work with us", title, body, cta = "Get in Touch", to = "/contact", testid = "closing-cta" }) {
    return (
        <section data-testid={testid} className="bg-cream py-24 md:py-36">
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 items-end">
                <div className="md:col-span-8">
                    <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
                    <Reveal delay={100}>
                        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-forest leading-[1.04] tracking-tight mt-8">
                            {title || <>Have a plot, project or opportunity <em className="italic">in mind?</em></>}
                        </h2>
                    </Reveal>
                    <Reveal delay={200}><p className="mt-8 text-base md:text-lg text-muted_text max-w-xl">{body || "We'd love to hear about it."}</p></Reveal>
                </div>
                <Reveal delay={300} className="md:col-span-4 md:justify-self-end">
                    <PillButton to={to} testid={`${testid}-button`}>{cta}</PillButton>
                </Reveal>
            </div>
        </section>
    );
}
